// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"68676ac5","346":"84848596","480":"9cfeef6c","558":"722e055e","570":"2a37060b","780":"af546743"}[chunkId] + ".chunk.js";
};